import { ZzimProducts } from 'common/types/entities/api/zzim'
import { StateKey } from 'common/utils/flipState'
import { fetchZzimedRelationProducts, setRelationProductZzim } from 'common/services/zzim'
import { Error } from 'common/types/entities/error'
import HttpStatus from 'common/utils/httpStatus'

const FETCH = '/product/relationZzim/FETCH'
const SET = '/product/relationZzim/SET'

const initialState: ZzimProducts = {}

export const fetchZzimRelationProducts = (curState: StateKey, productIds: number[]) => async dispatch => {
  const ids = productIds.map(id => `${id}_WINDOW`)
  const zzimProducts = await fetchZzimedRelationProducts(ids)

  dispatch({
    curState,
    zzimProducts: zzimProducts || initialState,
    type: FETCH,
  })
}

export const toggleRelationProductZzim = (
  curState: StateKey,
  relationProductId: number,
  zzimed: boolean,
) => async dispatch => {
  const id = `${relationProductId}_WINDOW`
  const responseData = await setRelationProductZzim(id, zzimed)
  if (!responseData.bSuccess) {
    const error: Error = {
      status: responseData.sErrorCode === 'ACCESS_DENIED' ? HttpStatus.UNAUTHORIZED : HttpStatus.OK,
      message: responseData.htReturnValue.sMessage,
    }
    throw error
  }

  dispatch({
    curState,
    id,
    type: SET,
  })
}

const updateZzim = (zzimProducts: ZzimProducts, id: string) => {
  const zzimProduct = zzimProducts[id]
  zzimProducts[id].zzim = !zzimProduct.zzim
  return {
    ...zzimProducts,
  }
}

// reducers
const relationProductsZzimReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return action.zzimProducts
    case SET:
      return updateZzim(state, action.id)
    default:
      return state
  }
}

export default relationProductsZzimReducer
